import type { PermissionsDataResponse, RolesDataResponse } from '~/types'

export default function usePermissionsApi() {
	async function GetAllRoles(cacheTime = 1000) {
		const { data, error } = await useAPI<IRequestResponse<RolesDataResponse[]>>('/roles')
		if (!error.value && data.value?.data) {
			const { setRoles } = useUser()
			setRoles(data.value.data)
		}
		return data.value
	}
	async function GetAllPermissions() {
		return await useAPI<IRequestResponse<PermissionsDataResponse[]>>('/permissions?user_type=business')
	}

	async function GetRole(roleId: string) {
		return await useAPI<IRequestResponse<PermissionsDataResponse>>(`/roles/${roleId}`)
	}
	async function DeleteRole(roleId: string) {
		return await useAPI<IRequestResponse>(`/roles/${roleId}`, {
			method: 'DELETE',
			redirect: 'follow'
		})
	}

	async function EditRole(option: EditRoleContext) {
		return await useAPI<IRequestResponse>(`/roles/${option.roleId}`, {
			method: 'PATCH',
			body: option
		})
	}

	async function CreateRole(option: EditRoleContext) {
		const { data } = await useAPI<IRequestResponse>('/roles', {
			method: 'POST',
			body: option
		})
		return data.value
	}

	return {
		GetAllRoles,
		GetAllPermissions,
		GetRole,
		DeleteRole,
		EditRole,
		CreateRole
	}
}
